import m from "mithril";
import {CellItem} from "./cellItem";
import {XmlTagInfo} from "../xmlTagProvider";
import {LabelView} from "../../ui/items/labelView";

export class LabelItem extends CellItem {

    public labelFor: string;

    static fromXml(config: XmlTagInfo) {
        return new LabelItem(config);
    }

    constructor(config: XmlTagInfo) {
        super(config);
        this.labelFor = config.attributes['for'];
    }

    getView() {
        // @ts-ignore
        return m(LabelView.component, {cellItem: this});
    }

    resourcesToPreload() {
        return this.getSimpleContentResources(this.childrenTags);
    }
}